export default __webpack_public_path__ + "static/media/python.1ac5ba5f.svg";